export interface OptionsShape {
  id: number;
  value: string;
  checked?: boolean;
}

export const getSuffixText = (amountOfElements: number): string =>
  amountOfElements > 1 ? `+${amountOfElements - 1}` : '';
